import { ImageSource, Loader, Resource, Sound } from "excalibur";
import { TexturePackerJSON } from "./utils/AtlasLoader";

/**
 * Game Resources - All images and sprite atlas JSON files
 */
export const Resources = {
    // Background
    Background: new ImageSource('/img/background/background_large_01.png'),
    GameOverBackground: new ImageSource('/img/background/gameoversceen01.png'),
    VictoryBackground: new ImageSource('/img/background/winningscreen01.png'),

    // UI
    IntroCharacter: new ImageSource('/img/ui/introscreen_character.png'),
    OpeningInstructions1: new ImageSource('/img/ui/openinginstructions_page01.png'),
    OpeningInstructions2: new ImageSource('/img/ui/openinginstructions_page02.png'),
    OpeningInstructions3: new ImageSource('/img/ui/openinginstructions_page03.png'),

    // Projectiles
    Antibody: new ImageSource('/img/projectiles/antibody.png'),
    Cytokine: new ImageSource('/img/projectiles/cytokine.png'),

    // Macrophage animations
    MacrophageWalkImage: new ImageSource('/img/animations/macrophage_walk.png'),
    MacrophageWalkJson: new Resource<TexturePackerJSON>('/img/animations/macrophage_walk.json', 'json'),
    MacrophageShootImage: new ImageSource('/img/animations/macrophage_shoot.png'),
    MacrophageShootJson: new Resource<TexturePackerJSON>('/img/animations/macrophage_shoot.json', 'json'),

    // Antigen animation
    AntigenImage: new ImageSource('/img/animations/antigen.png'),
    AntigenJson: new Resource<TexturePackerJSON>('/img/animations/antigen.json', 'json'),

    // Lipid Raft animation
    LipidRaftImage: new ImageSource('/img/animations/lipid_raft.png'),
    LipidRaftJson: new Resource<TexturePackerJSON>('/img/animations/lipid_raft.json', 'json'),

    // Enemy animations
    InfluenzaImage: new ImageSource('/img/animations/enemy_influenza.png'),
    InfluenzaJson: new Resource<TexturePackerJSON>('/img/animations/enemy_influenza.json', 'json'),
    RhinovirusImage: new ImageSource('/img/animations/enemy_rhinovirus.png'),
    RhinovirusJson: new Resource<TexturePackerJSON>('/img/animations/enemy_rhinovirus.json', 'json'),
    AdenovirusImage: new ImageSource('/img/animations/enemy_adenovirus.png'),
    AdenovirusJson: new Resource<TexturePackerJSON>('/img/animations/enemy_adenovirus.json', 'json'),
    MutatedStrainImage: new ImageSource('/img/animations/enemy_mutated_strain.png'),
    MutatedStrainJson: new Resource<TexturePackerJSON>('/img/animations/enemy_mutated_strain.json', 'json'),

    // Weapon animations
    NeutrophilNetImage: new ImageSource('/img/animations/neutrophil_net.png'),
    NeutrophilNetJson: new Resource<TexturePackerJSON>('/img/animations/neutrophil_net.json', 'json'),
    PerforinZoneImage: new ImageSource('/img/animations/perforin_zone.png'),
    PerforinZoneJson: new Resource<TexturePackerJSON>('/img/animations/perforin_zone.json', 'json'),

    // Music
    MenuMusic: new Sound('/music/menu_music.mp3'),
    GameMusic: new Sound('/music/game_music.mp3'),

    // SFX
    Hit1: new Sound('/sfx/hit1.wav'),
    Hit2: new Sound('/sfx/hit2.wav'),
    Hit3: new Sound('/sfx/hit3.wav'),
    Hit4: new Sound('/sfx/hit4.wav'),
    CytokineStorm: new Sound('/sfx/cytokine_storm.wav'),
    GameOver: new Sound('/sfx/game_over.wav'),
    GameWin: new Sound('/sfx/game_win.wav'),
} as const;

export const loader = new Loader();
for (const res of Object.values(Resources)) {
    loader.addResource(res);
}
